import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { HomeScreen } from "../../screens/home/HomeScreen.tsx";

/** `/`: Home, and the whole way there (`screens/home/stage.ts`). */
export const Route = createFileRoute("/_app/")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("home.overview", {})),
  component: HomeScreen,
});
